import React from 'react';
import { OrbOrderStatus } from '../../types/orderTypes';
import styles from './ORBDisplay.module.css';
import { useDockets } from '@/hooks/useDockets';
import { useDocketPagination } from '@/hooks/useDocketPagination';
import { useResponsiveGrid } from '@/hooks/useResponsiveGrid';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { useSelection } from '@/libs/onboarding';
import { storageSvc } from '@/services/storageServiceClient';
import { Timer } from '@/components/timer';
import { OfflineBanner } from '@/components/offline-banner/OfflineBanner';
import { OrderColumn } from '@/features/orb-display/order-column/OrderColumn';
import { useAutoTokenRefresh } from '@/hooks/useAutoTokenRefresh';

export const ORBDisplay: React.FC = () => {
  const { preparing: preparingOrders, ready: readyOrders } = useDockets();
  const gridDimensions = useResponsiveGrid();
  const { organization } = useSelection(storageSvc);
  const isOnline = useNetworkStatus();
  const { preparing, ready } = useDocketPagination({
    preparingOrders,
    readyOrders,
    pagination: {
      preparing: gridDimensions.preparing.totalCards,
      ready: gridDimensions.ready.totalCards,
    },
  });
  useAutoTokenRefresh();

  return (
    <div className={styles.container}>
      {!isOnline && <OfflineBanner />}

      <div className={styles.main}>
        <div className={styles.sectionsContainer}>
          <OrderColumn
            title="Preparing..."
            status={OrbOrderStatus.PREPARING}
            orders={preparing.orders}
            gridDimensions={gridDimensions.preparing}
            currentPage={preparing.currentPage}
            totalPage={preparing.totalPage}
          />

          <OrderColumn
            title="Ready!"
            status={OrbOrderStatus.READY}
            orders={ready.orders}
            gridDimensions={gridDimensions.ready}
            currentPage={ready.currentPage}
            totalPage={ready.totalPage}
          />
        </div>
      </div>

      <div className={styles.footer}>
        <Timer />
        <div>{organization?.name}</div>
      </div>
    </div>
  );
};
